import React from 'react';

import { RequestExceptionWithResponse } from '@eika-infrastruktur/request';
import { LinkButton, StandardButton } from '@eika/button';
import { ButtonWithSpinner } from '@eika/button-with-spinner';
import { WarningCard } from '@eika/card';
import { CheckmarkAnimation } from '@eika/checkmark-animation';

import useTranslation, { format } from '../../hooks/useTranslation';
import { accountTrackingIDs } from '../../utils/gtm/trackIDs/account';
import ActionResultInfo from '../shared/ActionResultInfo/ActionResultInfo';
import CenteredModalContent from '../shared/CenteredModalContent/CenteredModalContent';

import './AddAuthorizedCustomerModal.scss';

interface Props {
    success: boolean;
    error?: RequestExceptionWithResponse;
    onClose: () => void;
    deleteDisponent: () => void;
    name: string;
    isLoading: boolean;
}

const DeleteAuthorizedCustomer: React.FC<Props> = ({ success, error, onClose, deleteDisponent, name, isLoading }) => {
    const translated = useTranslation();

    if (success || error) {
        return (
            <ActionResultInfo
                title={format(translated.accountDetails.addAuthorizedCustomer.deleteConfirmation, name)}
                error={error}
                retry={onClose}
                icon={<CheckmarkAnimation />}
                successButton={
                    <StandardButton onClick={onClose}>
                        {translated.accountDetails.addAuthorizedCustomer.doneButton}
                    </StandardButton>
                }
            />
        );
    }

    return (
        <CenteredModalContent>
            <WarningCard
                title={format(translated.accountDetails.addAuthorizedCustomer.deleteConfirmationQuestion, name)}
                isModal
            >
                <div className="add-authorized-customer__button-container">
                    <ButtonWithSpinner
                        buttonType="positive"
                        onClick={deleteDisponent}
                        showSpinner={isLoading}
                        data-track-id={accountTrackingIDs.deleteAuthorizedCustomer.id}
                        data-track-linkname="submit"
                    >
                        {translated.accountDetails.addAuthorizedCustomer.deleteConfirmationButton}
                    </ButtonWithSpinner>
                    <LinkButton
                        onClick={onClose}
                        data-track-id={accountTrackingIDs.deleteAuthorizedCustomer.id}
                        data-track-linkname="navigate__close"
                    >
                        {translated.accountDetails.addAuthorizedCustomer.deleteCancelButton}
                    </LinkButton>
                </div>
            </WarningCard>
        </CenteredModalContent>
    );
};

export default DeleteAuthorizedCustomer;
